import React from 'react';
import "./QualityControl.css";

function QualityControl() {
  return (
    <div className='qualitycontrol-container'>
      <div className="qualitycontrol-content">

        <div className='qualitycontrol-header'>
          <h3>KALİTE KONTROL VE TEST</h3>
        </div>
        <div className='pro-text-promotion'>
          <li>Üretilen her lot, toplam izlenebilirlik ve kalite gereksinimlerinin kontrolünü sağlayan Gibitre Aletleri Sistemlerinde kontrol edilir ve kaydedilir.</li>
          <li>Kalite kontrol için her lot teslim edilmeden önce sertlik değeri ve reometre ile kontrol edilir ve test sonuçları rapor halinde müşteri ile paylaşılır.</li>
          <li>Ayrıca mekanik testlerin yanısıra, müşteri isteklerine göre soğuk dayanım, limit oksijen indeksi, ozon testi gibi özel testler yapılabilmektedir.</li>

        </div>

        <div className='qualitycontrol-header-bottom'>
          
        </div>

      </div>
    </div>
  )
}

export default QualityControl